export default "__VITE_ASSET__BcGMlo76__"